import React from 'react';
import { getData, deleteData, } from '../../../core/HttpAction';
import Table from '../../../core/Table'; 
import {withRouter,Link} from 'react-router-dom';
import {permissionCheck} from '../../../core/Permission';
import Nopermission from '../../../core/Nopermission';

const Url='/book';
const backUrl='/library/bookcategory'; 

const CellColumn=({row})=>{
    return row.status==1 ? 'Active':'In-Active';
};
const QuantityColumn=({row})=>{
    return <span className="uk-badge uk-badge-primary">{row.quantity}</span>;
};
const IssuedColumn=({row})=>{
    return <span className="uk-badge uk-badge-danger">{row.issued_count}</span>;
};
const AvailabilityColumn=({row})=>{
    return <span className="uk-badge uk-badge-success">{row.availability_count}</span>;
};

const ViewColumn=({props,row})=>{
    return  <Link to={`/library${Url}view/${row.book_id}`}><span className="uk-badge">View</span></Link>;
};

const columns=[
    {
        key:'title',
        displayName:'Title',
        styles:{width:'250px'}
    },      
    {
        key:'author_name',
        displayName:'Author Name'
    }, 
    /*{
        key:'edition',
        displayName:'Edition'
    },*/
    {
        key:'quantity',
        displayName:'Quantity',
        Cell:QuantityColumn
    },
    {
        key:'issued_count',
        displayName:'Issued Count',
        Cell:IssuedColumn
    },
    {
        key:'availability_count',
        displayName:'Available Count',
        Cell:AvailabilityColumn
    },
    {
        key:'status',
        displayName:'Status',
        Cell:CellColumn
    },
    {
        key:'action',
        displayName:'Action',
        Cell:ViewColumn
    },   
];
  
class ListPage extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            params:{
                search_term: '',
                startDate: '',
                endDate:'', 
                limit:10,
                page:1,
                book_category_id:this.props.match.params.id
            }, 
            data:[],
            preloader:true,
        };
        this.fetchData = this.fetchData.bind(this);  
        this.handleFetch = this.handleFetch.bind(this);  
        this.delete = this.delete.bind(this);  
    }
 
    componentDidMount(){
        this.fetchData();
    }

 
    fetchData(){
        getData(Url,this.state.params).then((res)=>{ 
            this.setState({data:res.data,preloader:false}); 
        });
    }

    handleFetch(params){
        this.setState({params:{...params, book_category_id:this.props.match.params.id},preloader:true},()=>{
            this.fetchData();
        });
    }

    delete(id){
        let page=1;
        this.setState({preloader:true,params:{...this.state.params,page}});
        deleteData(Url+'/'+id).then((res)=>{
            if(res.data.status===200){
                this.fetchData();
            }else{
                alert('Not delete');
                this.setState({preloader:false});
            }
        });   
    }
    render() {
        let {preloader,data}=this.state;  
        const title = data.data && data.data.length ?data.data[0]['book_category']:''; 

        const role=permissionCheck('bookcategory','DetailView');
        if(!role)
            return <Nopermission/>;

        return (
            <Table
                data={data}
                handleFetch={this.handleFetch.bind(this)}
                preloader={preloader}
                permission="bookcategory"
                title={`Book Category - ${title} (${data.total})`}
                columns={columns}
                primaryKey="book_category_id" 
                backbtn={backUrl}
            /> 
        );
    }
}
 
export default  withRouter(ListPage); 



// WEBPACK FOOTER //
// ./src/components/Library/BookCategory/CategoryView.js